// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__-SHVh","select":"Header_select__3W2f6","clinic":"Header_clinic__251oG"};